import { combineReducers } from "redux";
import { SnackBarReducer, LoginReducer } from "./Global/GlobalReducer";

export const reducers = combineReducers({
    SnackBarData: SnackBarReducer,
    LoginData: LoginReducer,
})